import { styled } from '@material-ui/core/styles';
import React, { useState } from 'react';
import { TabsBar } from './TabsBar';

const Root = styled('div')({
    width: '100%',
});

const Panel = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.grey[100],
    padding: theme.spacing(4),
}));

interface TabItem {
    content: React.ReactNode;
    tabLabel: string | React.ReactNode;
}

interface AccountTabsProps {
    tabs: TabItem[];
    onChange?: (tabIndex: number) => void;
    initialActiveTab?: number;
    activeTab?: number;
    keepMounted?: boolean;
}

const AccountTabs: React.FC<AccountTabsProps> = ({ tabs, onChange, initialActiveTab = 0, activeTab, keepMounted }) => {
    const [tabIndex, setTabIndex] = useState(initialActiveTab);

    const handleChange = (newTabIndex: number) => {
        setTabIndex(newTabIndex);
        if (onChange) onChange(newTabIndex);
    };

    return (
        <Root>
            <TabsBar tabs={tabs.map(tab => tab.tabLabel)} active={activeTab ?? tabIndex} onChange={handleChange} />
            {tabs.map((tab, index) => (
                <TabPanel key={index} value={activeTab ?? tabIndex} index={index} keepMounted={keepMounted}>
                    {tab.content}
                </TabPanel>
            ))}
        </Root>
    );
};

export default AccountTabs;

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
    keepMounted?: boolean;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, keepMounted, ...other } = props;

    return (
        <div role="tabpanel" hidden={value !== index} {...other}>
            {(keepMounted || value === index) && <Panel>{children}</Panel>}
        </div>
    );
}
